import React, { Component } from 'react';
import './ceasa.css';

class App extends Component {
  render() {
    return (
      <div id="body_">
            <div id="header">
      
          <h1 id="titulo">Política de privavidade do app ceasa serviços</h1>
          <h4 id="texto"></h4>
          </div>
           <p id="footer">
           Por meio deste documento, são estabelecidos os termos e as condições gerais para a utilização da Plataforma ceasa serviços (“CEASA SERVIÇOS PR”), por Você (“Você”), que é nosso usuário.
           </p>


           <div id="header">
      
           <h1 id="titulo">#SuaResponsabilidade</h1>
           <h4 id="texto"></h4>
           </div>
           <p id="footer">
           Esperamos de você uma comunicação respeitosa e não agressiva entre colonos e movimentadores, não agindo de maneira desrespeitosa, sempre zelando pela ética e integridade.
           </p>


           <div id="header">
      
      <h1 id="titulo">#SeuDireito</h1>
      <h4 id="texto"></h4>
      </div>
      <p id="footer">
      Ao criar uma conta no CEASA SERVIÇOS PR, nós iremos lhe receber em nossa plataforma para atendimentos, documentos, dúvidas e soluções.Nós sinalizamos para que você fique tranquilo, pois suas informações estarão seguras em nossa plataforma!
      </p>



      <div id="header">
      
      <h1 id="titulo">#como funciona o app?</h1>
      <h4 id="texto"></h4>
      </div>
      <p id="footer">
      Trabalhamos apenas e com usuários que prestão serviços ao ceasa,onde movimentadores que são usuários comuns possam ter serviços diários com colonos, que são usuários que trazem a mercadoria ao ceasa pr.
      </p>


      <div id="header">
      
      <h1 id="titulo">#quem pode usar o ceasa serviços app?</h1>
      <h4 id="texto"></h4>
      </div>
      <p id="footer">
      Todos os usuários maiores de 18 anos, que disponibilizam do seu tempo para prestarem serviços diários ao ceasa como movimentador ou como colono.
      </p>



      <div id="header">
      
      <h1 id="titulo">#nosso sistema interno de regras</h1>
      <h4 id="texto"></h4>
      </div>
      <p id="footer">
      Todos os usuários do app 'ceasa serviços pr', serão redirecionados a base para finalização do pré-cadastro como movimentador ou como
      colono, e nosso analistas avaliarão cada perfil CNPJ, CPF para disponibilizar o acesso ao app com senha e login realizados no pré-cadastro.
      Todos sem execeção deverão comparecer ao setor administrativo para analise dos dados cadastrados para liberação de acesso do mesmo.
      </p>

      <div id="header">
      
      <h1 id="titulo">#regras e políticas de respeito ao próximo</h1>
      <h4 id="texto"></h4>
      </div>
      <p id="footer">
      Todos os usuários do app 'ceasa serviços pr', deverão respeitar o próximo devidamente como ser humano e como parceiro ceasa.
      Nós não toleramos xingamentos, ofensas ao próximo em nosso sistema/app, caso ocorra a secretaria irá tomar as providências necessárias de
      bloqueios de acessos ao sistema/app 'ceasa serviços pr'.
      </p>
           </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js